<!--  抽卡结果-->
<template>
  <div class="drawCard" v-show="show">
    <div class="box">
      <h1>快去填写地址吧~</h1>
      <img
        class="img"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/synthesisCard.png"
        alt=""
      />
      <div class="btn">
        <button class="accept" @click="jumpAddress">填写地址</button>
      </div>
      <div class="close" @click="changeShow"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  props:{
    activityId:{
      type:Number,
      default:''
    },
    synthesisRes:{
       type:Number,
      default:''
    }
  },
  computed: {},
  watch: {},
  methods: {
    changeShow() {
      this.show = !this.show;
    },
    jumpAddress() {
      this.$router.push({ path: '/cardAdress', query: {cardActiveId:this.activityId,recordId:this.synthesisRes} });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.drawCard {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  background: rgba($color: #000, $alpha: 0.8);
  .box {
    width: 100%;
    min-height: 886px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/synthesisCard-b%20g.png')
      no-repeat;
    background-size: 100%;
    h1 {
      padding-top: 151px;
      padding-bottom: 19px;
      color: #fff;
      font-weight: 500;
      font-size: 30px;
      text-align: center;
    }

    .img {
      display: block;
      width: 519px;
      height: 692px;
      margin: 0 auto 36px;
    }
    .btn {
      display: flex;
      justify-content: space-around;
      margin: 36px auto 40px;
      padding: 0 116px;

      button {
        display: block;
        width: 250px;
        height: 80px;
        color: #fff;
        font-weight: 500;
        font-size: 32px;
        border-radius: 40px;
      }
      .accept {
        line-height: 80px;
        background: linear-gradient(180deg, #f86e77 0%, #ff2d5d 100%);
      }
    }
    .close {
      width: 66px;
      height: 66px;
      margin: 0 auto;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/close.png');
      background-size: 100%;
    }
  }
}
</style>
